export default __webpack_public_path__ + "static/media/Circled Play.0904563a.svg";